module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/b0t9rA/tc-custom/9781488012570.jpg?1706904714016",
      "alt": "This image is the cover for the book Stone Cold Texas Ranger"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stone Cold Texas Ranger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Texas Ranger puts it all on the line for a woman who has everything to lose in this romantic thriller.")]), _c('br'), _c('br'), _vm._v("Texas Ranger Vaughn Cooper doesn’t need or appreciate the “help” of some frivolous civilian on his case. Yet even this seasoned lawman can’t argue that Natalie Torres is on her game. She might even unlock the answers he needs to crack this kidnapping . . . if the bad guys don’t erase Natalie first."), _c('br'), _c('br'), _vm._v("With her home burned to the ground, Natalie has no choice but to hide out with Vaughn in a remote cabin. Spending time with the stone-cold officer should keep her mind strictly on the case. But there’s an unseen fire burning deep within Vaughn, and it’s making Natalie wonder just where the true danger might lie.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicole Helm\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nicole Helm writes down-to-earth contemporary romance and fast-paced romantic suspense. She lives with her husband and two sons in Missouri. Visit her website: www.nicolehelm.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0